<template>
 <div id="app">  
  <div class="container">
        
         
    <b-alert show>Consolidating Databases is alpha preview functionality.  You should expect that there may be gaps in the logic and flaws in the implementation.  <br/>
      Please report issues and suggestions to dbayard@amazon.com</b-alert>
      <br/>

    <span>
      Use this dialog to define a new simulated consolidated database that combines the raw metrics of your chosen individual databases:
    </span>
    <br/><br/>
                           
                              
              
      <div id="demo">
        <!-- SYNCHRONIZED WITH Batch.vue line 27 -->
        <b-table striped hover bordered fixed :items="childDatabases" class="table table-sm">

        </b-table>
      </div>

      <span> 
    Before merging, we need to check that these individual databases are compatible with each other to be merged.  The compatibility results are:
    </span> <br/><br/>
 
    <b-alert v-if="consolidateCheckSuccess == false" variant="danger" show>{{this.consolidateCheckMessage}}</b-alert>
    <b-alert v-if="consolidateCheckSuccess" variant="success" show>{{this.consolidateCheckMessage}}</b-alert>
    <br/><br/>

    <span v-if="consolidateCheckSuccess">

      <span> 
      Now, please provide some attributes to describe the new simuated consolidated database that we will create:
    </span> <br/><br/>
          <b-form >
                              

                             <div>
                                
                                <b-card bg-variant="light" class="text-left">
                  
                                    <b-form-group id="exampleInputGroup2" label="Customer Name:" label-for="customer">
                                      <b-form-input
                                        id="customer"
                                        type="text"
                                        v-model="userInput.customer"
                                        required
                                        placeholder="Enter customer name."
                                        >
                                      </b-form-input>
                                    </b-form-group>
                  
                                    <b-form-group id="exampleInputGroup3" label="Database Name:" label-for="batchname">
                                      <b-form-input
                                        id="batchname"
                                        type="text"
                                        v-model="userInput.batchname"
                                        required
                                        placeholder="Enter name for the new consolidated database."
                                      ></b-form-input>
                                    </b-form-group>
                  
                                   <b-form-group id="exampleInputGroup4" label="Description:" label-for="descr">
                                      <b-form-textarea
                                        id="descr"
                                        v-model="userInput.descr"
                                        required
                                        placeholder="Enter a description for this new consolidated database."
                                        :rows="3"
                                        :max-rows="6"
                                      ></b-form-textarea>
                                    </b-form-group>
                              
                                </b-card>
                              </div>
                              <br/><br/>

                              <b-button :disabled="(this.userInput.customer=='') || (this.userInput.batchname=='')" v-if="(this.consolidate_batch_id=='') && (this.consolidateMessage=='')" @click="consolidateDatabases" variant="success">Create a new Consolidated Database</b-button>

                            </b-form>


      <br/><br/>
      {{this.consolidateMessage}}
      <span v-if="this.consolidate_batch_id!=''">
        <br/><br/>
        New Consolidated Databases created successfully.  &nbsp;
        <br/><br/>
        <a :href="`/batch/${this.consolidate_batch_id}`" target="_blank">Open your new Consolidated Database in a new tab.</a>
      </span>  

    </span>
     <span v-if="false">
      app 2100 <br/>
consolidated 126 - <br/>



<br/> In adhoc charts, Update RAC/Instance drop-down controls & charts

<br/> Add check to fail non-x86 databases for now.

<br/> Test with combinations of child databases that are RAC, Exadada, PDBs, STATSPACK, and non-x86.  Look at accuracy of rolled up data.  Also see if charts display properly and PDF is generated OK.

<br/> Test with large number of databases (10, 20, 30)

<br/> Add a check to batch if a scenario prices out more or uses more licensing than the sum of its pieces

<br/> Add Consolidated ICON to Metrics. Maybe add an alert "Work in progress.. use AutoRight Sizer to view details."   Update RAC/Instance drop-down controls & charts

<br/> Add Consolidated ICON to Main 

<br/> Think about MultiAZ logic.  What if one child is RAC and one isnt?  Should that be MAZ?

<br/> Check that sharing still works with Consolidated DBs/batches

<br/> NICE TO HAVE Add DBCSI URLs for child databases to PDF.  Add link to RDS-Oracle Mulitenant docs or blog?


<br/> May need to switch to most common duration versus average duration.
<br/> Validate that it works correctly when a child database is on Exadata.  Things like chart dialogs may be goofy or confusing.
<br/> Add support for child databases that are RAC.  What about adding up memory when child database is RAC???  What about MultiAZ, What about RAC icon, What about timechartRACcontainer usage when both RAC and Consolidated, if CONSOLIDATED_DATABASES>0, Watch out for false RAC thinking (because NUM_INSTANCES>0). 
<br/> Add support for non-x86 child databases
<br/> Add support for PDB child databases.  If PDBs, need to carry over IS_PDB and Outliers.
<br/> add customer to apps.js 3396 /dbcsi/batch/:batch_id.  Then use it to default customer name in form.
     </span>
  </div>
 </div>  
</template>

<script>
import { API } from "aws-amplify";


export default {
  name: "ConsolidateModal",
  props: ["user", "param_items"],
  data: () => ({
    loaded: false,
    shareMode: false,
    batchItems: [{ name: "Retrieving Data..." }],
    childDatabases: [ {collection_id: 12345, name: "DB1", start_date: "2024-01-01 10:45", end_date: "2024-02-01 10:45", snapshots: 1080, duration: 30, statspack_awr: "AWR"}],
    userInput: {
        customer: "",
        batchname: "",
        descr: ""
      },
    start_date: "",
    end_date: "",
    consolidateMessage: "",
    consolidateCheckMessage: "",
    consolidateCheckSuccess: false,
    consolidate_batch_id: "",
    consolidate_collection_id: ""
    

  }),
  async mounted() {
    this.loaded = false;
    
    /* this.collection_id = this.param_collection_id;
    // is this shareMode?
    if ( (this.param_collection_id.substring(0,2)=="SD")  || (this.param_collection_id.substring(0,2)=="SB")) {
      // console.log("shareMode");
      this.collection_id=this.param_collection_id.substring(2).split('-')[1];
      this.shareMode=true;
    }
    
    */



    
    var tries = 2;
    var batchsuccess=false;
    var isOK = true;

    if (this.param_items != undefined) {
      this.batchItems = JSON.parse(this.param_items);
    }  

		if (!isOK) return;

        //do a put to /collections
        const putParams = {
          body: {
            action: "PREVIEW",
            childDatabases: this.batchItems
          }
        };


    // console.log("I am here1");
    tries = 1;
    while (tries > 0) {
      await API.put(
        "dbcsiAPI",
        `/dbcsi/consolidate`,
        putParams
      )
        .then(response => {
          
          this.childDatabases = response.data.childDatabases;
          
  


          tries = 0;
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("ConsolidateModal Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });

      tries -= 1;
    }

    var checkOK = true;
    var local_statspack_awr = this.childDatabases[0].statspack_awr;
    var local_duration = this.childDatabases[0].duration;
    var local_platform = this.childDatabases[0].platform;
    var max_start = this.childDatabases[0].start_date;
    var min_end = this.childDatabases[0].end_date;
    var min_start = this.childDatabases[0].start_date;
    var max_end = this.childDatabases[0].end_date;
    for (var ii = 1; ii < this.childDatabases.length; ii++) {
      if (local_statspack_awr!=this.childDatabases[ii].statspack_awr) {
        this.consolidateCheckMessage += " ERROR: Can't consolidate AWR and STATSPACK databases. ";
        checkOK = false;
        break;
      }
      if (local_platform!=this.childDatabases[ii].platform) {
        this.consolidateCheckMessage += " ERROR: Can't consolidate databases from different Platforms. ";
        checkOK = false;
        break;
      }
      if ((local_duration > this.childDatabases[ii].duration+2) || (local_duration < this.childDatabases[ii].duration-2) ){
        this.consolidateCheckMessage += " ERROR: Can't consolidate databases when the average snapshot duration varies by more than a couple of minutes. Please only pick databases with the same Duration. ";
        checkOK = false;
        break;
      }
      if (this.childDatabases[ii].is_pdb=='YES' ){
        this.consolidateCheckMessage += " ERROR: DBCSI cannot yet consolidate PDB databases (it is a work-in-progress). For now, please only pick non-PDB databases. ";
        checkOK = false;
        break;
      }
      if (this.childDatabases[ii].start_date>max_start) {
        max_start = this.childDatabases[ii].start_date;
      }
      if (this.childDatabases[ii].end_date<min_end) {
        min_end = this.childDatabases[ii].end_date;
      }
      if (this.childDatabases[ii].start_date<min_start) {
        min_start = this.childDatabases[ii].start_date;
      }
      if (this.childDatabases[ii].end_date>max_end) {
        max_end = this.childDatabases[ii].end_date;
      }

    }
    
    if (checkOK) {
      if (this.childDatabases.length>10) {
        this.consolidateCheckMessage += " ERROR: Can't consolidate more than 10 databases at a time. ";
        checkOK = false;
      }
     if (max_start > min_end) {
        this.consolidateCheckMessage += " ERROR: Can't consolidate databases when the minimum end_date is earlier than the maximum start_date. ";
        checkOK = false;
      }
      
    }
    
    if (checkOK) {
      this.consolidateCheckMessage = "Checks passed.  These databases can be consolidated for the time range from "+max_start+ " to " + min_end + "." ;
      this.start_date = max_start;
      this.end_date = min_end;

      var st2 = new Date(max_start);
      var st1 = new Date(min_start);
      var diff0 = Math.round((st2-st1)/1000/60/60/24);
       st2 = new Date(max_end);
       st1 = new Date(min_end);
      var diff1 = Math.round((st2-st1)/1000/60/60/24);

      if ((diff0>4)||(diff1>4)) {
        this.consolidateCheckMessage = this.consolidateCheckMessage + " Note: the start of the consolidated time range is " + diff0 + " days different than the earliest start time ("+ min_start + ") while the end of the time range is " + diff1 + " days than the latest end time (" + max_end + ").  The time range difference may result in different p99 calculations than you see at an individual database level.";
      }


      console.log("delta", Math.round((st2-st1)/1000/60/60/24), max_end-min_end);
    }  

    this.consolidateCheckSuccess = checkOK;


    this.loaded = true;

  },
  methods: {

    async consolidateDatabases() {
      
      
      this.consolidateMessage = "Creating a new Consolidated database... Please wait... Do not leave this page yet.";

      
      var success = true;
      
      
      
        //CREATE-START
        var putParams = {
          body: {
            action: "CREATE-START",
            userInput: this.userInput,
            start_date: this.start_date,
            end_date: this.end_date,
            childDatabases: this.batchItems
          }
        };


      // console.log("I am here1");
      var tries = 1;
      var temp_consolidate_batch_id = '';
      var temp_user = '';
      var temp_email = '';
      while (tries > 0) {
        await API.put(
          "dbcsiAPI",
          `/dbcsi/consolidate`,
          putParams
        )
          .then(response => {
            
            
            
            var new_batch_id = response.data.batch_id;
            var new_collection_id = response.data.collection_id
            temp_consolidate_batch_id = new_batch_id;
            temp_user = response.data.current_user;
            temp_email = response.data.current_user_email;
            this.consolidate_collection_id = new_collection_id;
            console.log("consolidateDatabases API.put: new batch_id=", new_batch_id, "  new collection_id=", new_collection_id);
            this.consolidateMessage = "CREATE-START finished "+this.childDatabases.length + " distinct databases. Please wait... Do not leave this page yet.";
            success=true;

    
  
  
            tries = 0;
            // console.log(this.genItems);
          })
          .catch(error => {
            console.log("ConsolidateModal Error:", error);
            this.consolidateMessage = "ERROR: CREATE-START failed: "+error;
            console.log("Will retry.  Attempts Left:", (tries-1));
            success = false;
          });
  
        tries -= 1;
      }
      


      //CREATE-METRICS1
        var putParams = {
          body: {
            action: "CREATE-METRICS1",
            start_date: this.start_date,
            end_date: this.end_date,
            batch_id: temp_consolidate_batch_id,
            collection_id: this.consolidate_collection_id,
            childDatabases: this.batchItems,
            current_user: temp_user,
            current_user_email: temp_email
          }
        };


      var tries = 1;
      while (success && (tries > 0) ) {
        await API.put(
          "dbcsiAPI",
          `/dbcsi/consolidate`,
          putParams
        )
          .then(response => {
            
            console.log("consolidateDatabases API.put: CREATE-METRICS1");
            this.consolidateMessage = "CREATE-METRICS1 finished "+this.childDatabases.length + " distinct databases. Please wait... Do not leave this page yet.";
            success=true;

            tries = 0;
            // console.log(this.genItems);
          })
          .catch(error => {
            console.log("ConsolidateModal Error:", error);
            this.consolidateMessage = "ERROR: CREATE-METRICS1 failed: "+error;
            console.log("Will retry.  Attempts Left:", (tries-1));
            success = false;
          });
  
        tries -= 1;
      }
            


/*

      //CREATE-METRICS2
        var putParams = {
          body: {
            action: "CREATE-METRICS2",
            start_date: this.start_date,
            end_date: this.end_date,
            batch_id: temp_consolidate_batch_id,
            collection_id: this.consolidate_collection_id,
            childDatabases: this.batchItems
          }
        };


      var tries = 1;
      while (success && (tries > 0) ) {
        await API.put(
          "dbcsiAPI",
          `/dbcsi/consolidate`,
          putParams
        )
          .then(response => {
            
            console.log("consolidateDatabases API.put: CREATE-METRICS2");
            this.consolidateMessage = "CREATE-METRICS2 finished "+this.childDatabases.length + " distinct databases. Please wait... Do not leave this page yet.";
            success=true;

            tries = 0;
            // console.log(this.genItems);
          })
          .catch(error => {
            console.log("ConsolidateModal Error:", error);
            this.consolidateMessage = "ERROR: CREATE-METRICS2 failed: "+error;
            console.log("Will retry.  Attempts Left:", (tries-1));
            success = false;
          });
  
        tries -= 1;
      }



      //CREATE-METRICS3
        var putParams = {
          body: {
            action: "CREATE-METRICS3",
            start_date: this.start_date,
            end_date: this.end_date,
            batch_id: temp_consolidate_batch_id,
            collection_id: this.consolidate_collection_id,
            childDatabases: this.batchItems
          }
        };


      var tries = 1;
      while (success && (tries > 0) ) {
        await API.put(
          "dbcsiAPI",
          `/dbcsi/consolidate`,
          putParams
        )
          .then(response => {
            
            console.log("consolidateDatabases API.put: CREATE-METRICS3");
            this.consolidateMessage = "CREATE-METRICS3 finished "+this.childDatabases.length + " distinct databases. Please wait... Do not leave this page yet.";
            success=true;

            tries = 0;
            // console.log(this.genItems);
          })
          .catch(error => {
            console.log("ConsolidateModal Error:", error);
            this.consolidateMessage = "ERROR: CREATE-METRICS3 failed: "+error;
            console.log("Will retry.  Attempts Left:", (tries-1));
            success = false;
          });
  
        tries -= 1;
      }

      //CREATE-METRICS4
        var putParams = {
          body: {
            action: "CREATE-METRICS4",
            start_date: this.start_date,
            end_date: this.end_date,
            batch_id: temp_consolidate_batch_id,
            collection_id: this.consolidate_collection_id,
            childDatabases: this.batchItems
          }
        };


      var tries = 1;
      while (success && (tries > 0) ) {
        await API.put(
          "dbcsiAPI",
          `/dbcsi/consolidate`,
          putParams
        )
          .then(response => {
            
            console.log("consolidateDatabases API.put: CREATE-METRICS4");
            this.consolidateMessage = "CREATE-METRICS4 finished "+this.childDatabases.length + " distinct databases. Please wait... Do not leave this page yet.";
            success=true;

            tries = 0;
            // console.log(this.genItems);
          })
          .catch(error => {
            console.log("ConsolidateModal Error:", error);
            this.consolidateMessage = "ERROR: CREATE-METRICS4 failed: "+error;
            console.log("Will retry.  Attempts Left:", (tries-1));
            success = false;
          });
  
        tries -= 1;
      }


      //CREATE-SUMMARY
        var putParams = {
          body: {
            action: "CREATE-SUMMARY",
            start_date: this.start_date,
            end_date: this.end_date,
            batch_id: temp_consolidate_batch_id,
            collection_id: this.consolidate_collection_id,
            childDatabases: this.batchItems
          }
        };


      var tries = 1;
      while (success && (tries > 0) ) {
        await API.put(
          "dbcsiAPI",
          `/dbcsi/consolidate`,
          putParams
        )
          .then(response => {
            
            console.log("consolidateDatabases API.put: CREATE-SUMMARY");
            this.consolidateMessage = "CREATE-SUMMARY finished "+this.childDatabases.length + " distinct databases. Please wait... Do not leave this page yet.";
            success=true;

            tries = 0;
            // console.log(this.genItems);
          })
          .catch(error => {
            console.log("ConsolidateModal Error:", error);
            this.consolidateMessage = "ERROR: CREATE-SUMMARY failed: "+error;
            console.log("Will retry.  Attempts Left:", (tries-1));
            success = false;
          });
  
        tries -= 1;
      }




      //CREATE-FINISH
        var putParams = {
          body: {
            action: "CREATE-FINISH",
            start_date: this.start_date,
            end_date: this.end_date,
            batch_id: temp_consolidate_batch_id,
            collection_id: this.consolidate_collection_id,
            childDatabases: this.batchItems
          }
        };


      var tries = 1;
      while (success && (tries > 0) ) {
        await API.put(
          "dbcsiAPI",
          `/dbcsi/consolidate`,
          putParams
        )
          .then(response => {
            
            console.log("consolidateDatabases API.put: CREATE-FINISH");
            this.consolidateMessage = "CREATE-FINISH finished "+this.childDatabases.length + " distinct databases.";
            this.consolidate_batch_id = temp_consolidate_batch_id;
            success=true;

            tries = 0;
            // console.log(this.genItems);
          })
          .catch(error => {
            console.log("ConsolidateModal Error:", error);
            this.consolidateMessage = "ERROR: CREATE-FINISH failed: "+error;
            console.log("Will retry.  Attempts Left:", (tries-1));
            success = false;
          });
  
        tries -= 1;
      }
      
*/      
      
      //CHECK-FINISH
        var putParams = {
          body: {
            action: "CHECK-FINISH",
            start_date: this.start_date,
            end_date: this.end_date,
            batch_id: temp_consolidate_batch_id,
            collection_id: this.consolidate_collection_id,
            childDatabases: this.batchItems
          }
        };


      var tries = 80;
      while (success && (tries > 0) ) {
        //sleep for 10 seconds (this also gives time for the S3 lambda to start)
        const sleep = (waitTimeInMs) => new Promise(resolve => setTimeout(resolve, waitTimeInMs));
        await sleep(10000); // sleep for 10 seconds

        await API.put(
          "dbcsiAPI",
          `/dbcsi/consolidate`,
          putParams
        )
          .then(response => {
            
            console.log("consolidateDatabases API.put: CHECK-FINISH", response);
            if (response.status=="SUCCESS") {
              this.consolidateMessage = "CHECK-FINISH finished "+this.childDatabases.length + " distinct databases.";
              this.consolidate_batch_id = temp_consolidate_batch_id;
              success=true;
              tries = 0;
            }
            else if (response.status=="ERROR") {
              console.log("ConsolidateModal CHECK-FINISH Error:", response.message);
              this.consolidateMessage = "ERROR: CHECK-FINISH failed: "+response.message;
              success=false;
              tries = 0;
            }
            else {
              console.log("ConsolidateModal CHECK-FINISH status:", response.status);
              this.consolidateMessage = "Waiting for new Consolidated Database metrics to be assembled: "+response.status+ " : " + response.message + " : " + tries;
              
            }
            
            
            
            // console.log(this.genItems);
          })
          .catch(error => {
            console.log("ConsolidateModal Error:", error);
            this.consolidateMessage = "ERROR: CHECK-FINISH failed: "+error;
            console.log("Will retry.  Attempts Left:", (tries-1));
            success = false;
          });
          

        tries -= 1;
      }
      
      if (!success) {
        this.consolidateMessage = "ERROR: CHECK-FINISH did not return SUCCESS after all retries";
      }
      
    }
    
  }
};
</script>